import { TimelineSection } from '../section-listing.model';

export class DocumentSection extends TimelineSection {
  documentTitle: string;
  documentNotes: string;
  documentUrl: string;
  blobPath: string;
  documentBase64Path: any;
  deleteDocument: boolean;
  documentExtension: string;

  constructor() {
    super();
    this.deleteDocument = false;
  }
}
